import { makeStyles, Spinner } from "@fluentui/react-components"
import type { ReactElement } from "react"
import { Navigate, useLocation } from "react-router"
import { useSession } from "../auth/session"
import { es } from "../i18n/es"

const useStyles = makeStyles({
  boot: {
    display: "grid",
    placeItems: "center",
    height: "100%",
  },
})

export interface RequireAuthProps {
  children: ReactElement
}

// Guard de rutas privadas: espera el bootstrap silencioso de la sesión y
// redirige a /login (recordando el destino) si no hay sesión.
export const RequireAuth = ({ children }: RequireAuthProps) => {
  const { status } = useSession()
  const location = useLocation()
  const styles = useStyles()

  if (status === "loading") {
    return (
      <div className={styles.boot}>
        <Spinner label={es.common.loading} />
      </div>
    )
  }
  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }
  return children
}
